import * as React from 'react'

import { AuthMetadata } from './auth'

export const useAuth = () => {
  const [user, setUser] = React.useState<AuthMetadata | null>(null)

  const isLoggedIn = () => user != null

  const getUsername = () =>
    user == null ? null : `${user.givenName} ${user.familyName}`

  return {
    getUsername,
    isLoggedIn,
    setUser,
    user
  }
}

export type AuthStore = ReturnType<typeof useAuth>

const Ctx = React.createContext<AuthMetadata | null>(null)
export const Auth = {
  Provider: Ctx.Provider,
  use: () => {
    const ctx = React.useContext(Ctx)
    if (ctx === null) {
      throw new Error('Must be wrapped within Auth.Provider')
    }
    return ctx
  }
}
